<template>
  <ExamStart :path="'/continueEdu'" style="margin-top: -86px;"></ExamStart>
</template>

<script>
  import ExamStart from '@/page/modules/exam/start'
  export default {
    components: { ExamStart },
    mounted () {
    },
    data () {
      return {
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/page/continueEdu/exam/start.vue